import { LoanRole } from '@matech/thebigpos-sdk'

import { Roles } from '../services/client'
import { RoleEnum } from '../hooks/useRoleList'

/**
 * Maps user roles to the roles they are allowed to assign.
 * An empty array means the user can assign all available roles.
 * Undefined means the user cannot assign any roles.
 */

const LOAN_OFFICER_ROLES = [
	RoleEnum.SupportingLoanOfficer,
	RoleEnum.LoanOfficerAssistant,
	RoleEnum.LoanProcessor,
]

const ROLE_PERMISSIONS: Record<string, LoanRole[]> = {
	[Roles.admin]: [],
	[Roles.loanOfficer]: LOAN_OFFICER_ROLES,
	[Roles.loanOfficerAssistant]: LOAN_OFFICER_ROLES,
	[Roles.loanProcessor]: LOAN_OFFICER_ROLES,
}

/**
 * Gets the allowed roles that a user can assign based on their role.
 * @param userRole - The role of the user who wants to assign roles
 * @returns Array of allowed roles, empty array for all roles, or undefined if no roles allowed
 */
const getAllowedRolesForUser = (
	userRole: string | null | undefined
): LoanRole[] | undefined => {
	if (!userRole) return undefined
	return ROLE_PERMISSIONS[userRole]
}

export const LO_USER_ROLES_TO_LOAN_ROLE: Record<string, RoleEnum> = {
	[Roles.loanOfficer]: RoleEnum.SupportingLoanOfficer,
	[Roles.loanOfficerAssistant]: RoleEnum.LoanOfficerAssistant,
	[Roles.loanProcessor]: RoleEnum.LoanProcessor,
}

export default getAllowedRolesForUser
